<template>
  <div class="chart-skeleton-loader-container" :class="{horizontal}">
    <div
      v-for="bar in barsCount"
      :key="bar"
      class="bar-chart"
      :style="{
        height: `${Math.random() * 101}%`,
        width: `${barWidth}px`,
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'LoadingChart',
  props: {
    horizontal: {
      type: Boolean,
      default: false,
    },

    barsCount: {
      type: Number,
      default: 6,
    },

    barWidth: {
      type: Number,
      default: 25,
    },
  },
}
</script>

<style scoped lang="scss">
.chart-skeleton-loader-container {
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  &.horizontal {
    transform: rotate(90deg);
  }
}

.bar-chart {
  background-color: rgba(0, 0, 0, 0.12);
  margin: 0 5px;
  position: relative;
}

.bar-chart::after {
  content: '';
  height: 100%;
  width: 100%;
  border-radius: var(--component-card-radius);
  background: linear-gradient(
    180deg,
    hsla(0, 0%, 100%, 0),
    hsla(0, 0%, 100%, 0.5),
    hsla(0, 0%, 100%, 0)
  );
  position: absolute;
  transform: translateY(-40%);
  left: 0;
  right: 0;
  top: 0;
  animation: loading 1.5s ease-in-out infinite alternate;
}

@keyframes loading {
  100% {
    transform: translateY(40%);
  }
}
</style>
